import {
    Box,
    FormControl,
    FormHelperText,
    OutlinedInput,
    Typography,
} from '@mui/material'
import { useEffect, useState } from 'react'
import { isValidEmail } from '../../utils/EntityAttributesUtils'
import { useTranslation } from 'react-i18next'

interface EmailInputProps {
    id: string
    label: string
    value: string
    onChange: any
    required?: boolean
    placeholder?: string
    disabled?: boolean
    errorMessage?: string
}
//onChange will always call, when input changes. even email is invalid. validation need to be done while saving as well
const EmailInput: React.FC<EmailInputProps> = ({
    id,
    label,
    value,
    onChange,
    required = false,
    placeholder,
    disabled = false,
    errorMessage,
}) => {
    const { t } = useTranslation()
    const [email, setEmail] = useState<string>('')
    const [error, setError] = useState<string>('')

    useEffect(() => {
        setEmail(value)
    }, [value])

    useEffect(() => {
        setError(errorMessage || '')
    }, [errorMessage])

    const handleChange = (id: string, value: string) => {
        setEmail(value)
        onChange(id, value)
    }
    const onblur = (value: string) => {
        if (value === '') {
            setError('')
        } else {
            if (isValidEmail(value)) {
                setError('')
            } else {
                setError(t('invalidEmail'))
            }
        }
    }

    const onEnter = (_value: string) => {}
    return (
        <Box sx={{ width: '100%' }}>
            <FormControl fullWidth>
                <Typography sx={{ opacity: '0.7', fontSize: '14px' }}>
                    {label}
                    {required ? '*' : ''}
                </Typography>
                <OutlinedInput
                    size="small"
                    id={id}
                    label=""
                    value={email}
                    onChange={(e) => handleChange(id, e.target.value)}
                    onBlur={(e) => onblur(e.target.value)}
                    sx={{
                        width: '100%',
                        '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button':
                            {
                                display: 'none',
                            },
                        '& input[type=number]': {
                            MozAppearance: 'textfield',
                        },
                        '& ::placeholder': {
                            // opacity: 0.14,
                        },
                    }}
                    placeholder={
                        placeholder ? placeholder : t('enterLabel', { label })
                    }
                    inputProps={{
                        style: {
                            fontSize: 14,
                            opacity:
                                email !== '' && email !== null ? '1' : '0.4',
                        },
                        type: `email`,
                        onKeyPress: (e) => {
                            if (e.key === 'Enter') {
                                onEnter((e.target as HTMLInputElement).value)

                                // write your functionality here
                                e.preventDefault()
                            }
                        },
                    }}
                    disabled={!!disabled}
                    error={error !== ''}
                />
                <FormHelperText error={!!error}>{error}</FormHelperText>
            </FormControl>
        </Box>
    )
}

export default EmailInput
